import React from 'react';

interface ProcessStepProps {
  number: number;
  title: string;
  description: string;
}

const ProcessStep: React.FC<ProcessStepProps> = ({ number, title, description }) => {
  return (
    <div className="flex">
      <div className="mr-4">
        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary text-white font-bold">
          {number}
        </div>
        {number < 5 && (
          <div className="h-full w-0.5 bg-primary/30 mx-auto my-2"></div>
        )}
      </div>
      <div className="pb-8">
        <h3 className="text-xl font-bold mb-2">{title}</h3>
        <p className="text-gray-600">{description}</p>
      </div>
    </div>
  );
};

const Process: React.FC = () => {
  const steps = [
    {
      title: 'Consulta Inicial',
      description: 'Na primeira consulta, realizamos uma avaliação detalhada da sua pele e discutimos seus objetivos estéticos. Este é o momento para entendermos suas expectativas e necessidades.',
    },
    {
      title: 'Plano de Tratamento',
      description: 'Com base na avaliação inicial, desenvolvemos um plano de tratamento personalizado que atenda às suas necessidades específicas, considerando seu tipo de pele, idade e objetivos.',
    },
    {
      title: 'Procedimento',
      description: 'Realizamos o procedimento escolhido com técnicas avançadas e produtos de alta qualidade, garantindo o máximo conforto e segurança durante todo o processo.',
    },
    {
      title: 'Pós-Procedimento',
      description: 'Fornecemos orientações detalhadas sobre os cuidados pós-procedimento para garantir os melhores resultados e uma recuperação tranquila.',
    },
    {
      title: 'Acompanhamento',
      description: 'Agendamos consultas de acompanhamento para avaliar os resultados e fazer ajustes no plano de tratamento, se necessário, garantindo sua total satisfação.',
    },
  ];

  return (
    <section className="py-16 bg-light">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="section-title">Nosso Processo</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Conheça como funciona o processo de atendimento na BotoHarmony, desde a consulta inicial até o acompanhamento pós-procedimento.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {steps.map((step, index) => (
            <ProcessStep
              key={index}
              number={index + 1}
              title={step.title}
              description={step.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;